var info_1 = "QCPlay,All Rights Reserved.";

// 移动端
var mFooterHtml = '<div>' +
    '<a style="margin: 0 auto;" target="_blank" href="https://snail.gamer.cc/"></a>' +
    '</p>' +
    '<p>' +
    '<a target="_blank" href="https://law.qingcigame.com/ja-jp/economic_law.html">資金決済法に基づく表示</a>' +
    '</p>' +
    '<p>' +
    '<a target="_blank" href="https://law.qingcigame.com/ja-jp/commercial_law.html">特定商取引法に基づく表示</a>' +
    '<p><a target="_blank" href="https://law.qingcigame.com/ja-jp/service_agreement.html">利用規約</a>&nbsp;&nbsp;&nbsp;<a target="_blank" href="https://law.qingcigame.com/ja-jp/privacy_policy.html">プライバシーポリシー</a></p>' +
    '</p>' +
    '<p><span class="copy-right">&copy;</span>' + info_1 + '</p>' +
    '</div>';
$('.m-footer').append(mFooterHtml);